import { IMenuItem, MenuItemType } from "dots-ui/dotsMenuBar";
import { NavigateFunction } from "react-router-dom";
import { horizontalBarMenuItems } from "../../../../../data/horizontalBarMenuItems";
import { IPortalKind, ResCallback } from "../../../../../models";
import { isMobileView } from "../../../appStates/appStates";
import { RightsHolderInfoViewModel } from "../../../../../generated/data-contracts";

export const HorizontalMenuItems = (
  verticalMenuItems: IMenuItem[],
  onLogout: () => void,
  navigate: NavigateFunction,
  res: ResCallback,
  portalKind: IPortalKind,
  ctxRightsHolder?: RightsHolderInfoViewModel,
  ctxRightsHolders?: RightsHolderInfoViewModel[],
  onRightsHolderActionClick?: () => void,
): MenuItemType[] => {
  const items = horizontalBarMenuItems(
    onLogout,
    navigate,
    res,
    portalKind,
    ctxRightsHolder,
    ctxRightsHolders,
    onRightsHolderActionClick,
  );

  if (isMobileView.value) {
    const smallScreenVerticalMenuItems: IMenuItem[] = [
      items["sessionInfo"],
      ...(portalKind.portalType === "authors" ? [items["rights-holders"]] : []),
      items["separator"],
      ...verticalMenuItems,
      items["user"],
      items["user-settings"],
      items["logout"],
    ];

    const mobileMenu: MenuItemType = {
      key: "mobile-toggle",
      icon: "fas fa-bars",
      className: "hide-submenu-expand-icon col-2 mobile-toggle",
      items: smallScreenVerticalMenuItems,
    };

    return [mobileMenu, items["logo"]] as MenuItemType[];
  }

  return [
    items["logo"],
    items["spacer"],
    ...(portalKind.portalType === "authors" ? [items["rights-holders"]] : []),
    items["separator"],
    items["sessionInfo"],
    items["separator"],
    items["user-settings"],
    items["separator"],
    items["logout"],
  ] as MenuItemType[];
};
